import styled, { css } from 'styled-components'
import { breakpoint } from '@sketch/global-styles'
import { ResizeHandle } from '@sketch/components'

export const Wrapper = styled.div<{
  isDesktopAndBigger: boolean
}>(
  ({ isDesktopAndBigger }) => css`
    display: flex;
    flex-direction: ${isDesktopAndBigger ? 'row' : 'column'};
    flex: auto;
    min-width: 0;
  `
)

export const DragBar = styled(ResizeHandle)(
  ({ theme }) => css`
    right: 0;

    &::before {
      right: 0;
    }

    z-index: ${theme.zIndex[1]};
  `
)

export const Sidebar = styled.div(
  ({ theme }) => css`
    /*
    We use sticky positioning to ensure the sidebar stays in place when scrolling,
    the height is the viewport height minus the header height, so the sidebar will always be visible.

    FIXME: https://linear.app/sketch/issue/SWEB-1815
    */
    position: sticky;
    top: 0;
    left: 0;

    height: calc(100vh - ${theme.header.height}px);
    overflow: auto;

    padding: 8px;
    background: ${theme.colors.background.secondary.A};

    display: flex;
    flex-direction: column;
    flex-shrink: 0;

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }
  `
)

export const Content = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  flex: auto;

  min-width: 0;
  margin-bottom: 44px;
  padding-left: 12px;
  padding-right: 12px;

  ${breakpoint('sm')`
    margin-top: 16px;
    padding-left: 24px;
    padding-right: 24px;
  `};

  background: ${({ theme }) => theme.colors.background.secondary.B};

  ${breakpoint('sm')`
        margin-top: 0px;
        padding-top: 16px;
        padding-left: 24px;
        padding-right: 24px;
      `};
`
